export default __webpack_public_path__ + "static/therapeutic-massage-6a50068861e1fd0030c96b9111ff5f8b.jpg";